import { render, staticRenderFns } from "./productDetailGroupOrder.vue?vue&type=template&id=38533132&scoped=true"
import script from "./productDetailGroupOrder.vue?vue&type=script&lang=js"
export * from "./productDetailGroupOrder.vue?vue&type=script&lang=js"
import style0 from "./productDetailGroupOrder.vue?vue&type=style&index=0&id=38533132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38533132",
  null
  
)

export default component.exports